export default function () {
  if ($(".js-hidden-events").length > 0) {
    $('.js-toggle-hidden-events').on('click',()=>{
      $(".js-hidden-events").removeClass("d-none");
      $('.js-toggle-hidden-events').addClass("d-none");
    })
  }
}
